export default __webpack_public_path__ + "static/anton-komisarov-b763855cef8bc90ece71e3c6c567a419.png";